import { configureStore } from '@reduxjs/toolkit';
import locationsReducer from './reducers/locationsReducer';
import paymentsReducer from './reducers/paymentsReducer';
import selectedMenuItemReducer from './reducers/selectedMenuItemLabel';
import expressCheckoutReducer from './reducers/expressCheckoutReducer';
import { useDispatch } from 'react-redux';

const store = configureStore({
  reducer: {
    locations: locationsReducer,
    payments: paymentsReducer,
    selectedMenuItem: selectedMenuItemReducer,
    expressCheckout: expressCheckoutReducer,
  },
});

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

export type RootState = ReturnType<typeof store.getState>;
export default store;
